import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién estoy comenzando con la Gemoterapia?',
  a: 'Sí. El Mega Pack está pensado para ayudarte a reunir fundamentos, recursos de consulta y una estructura práctica desde el inicio. Puedes avanzar a tu ritmo y volver a cada tomo cuando lo necesites.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Una vez confirmado el pago, recibirás acceso digital a todos los tomos y bonus en formato PDF.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Puedes usarlo desde tu celular, tablet o computadora. Si prefieres tener determinadas fichas a mano, también puedes imprimirlas.'
}, {
  q: '¿Qué diferencia a este pack de un curso?',
  a: 'No reemplaza una formación presencial ni acredita competencias clínicas. Es una biblioteca práctica de consulta, organización y acompañamiento para que tengas recursos claros en un solo lugar.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tienes 7 días de garantía. Si el material no es lo que esperabas, puedes solicitarla dentro de ese plazo según las condiciones de compra.'
}, {
  q: '¿Puedo compartirlo con otras personas?',
  a: 'No. Tu compra es personal. El material está protegido por derechos de autor y no puede reproducirse, revenderse ni distribuirse sin autorización.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-62" data-mp="16oh42mseuw0k">
      <div className="mb-12 text-center" data-id="element-63" data-mp="16pif4r9ffiia">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-purpleDark md:text-4xl" data-id="element-64" data-mp="rz2v3fsqyglp">
          <span className="mr-3" data-id="element-65" data-mp="wxmfvcvltmch">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-66" data-mp="iyd36n6lxad9">
        {faqs.map((faq, index) => <div key={faq.q} className="glass-panel overflow-hidden rounded-2xl border-brand-purple/20" data-id="element-67" data-mp="iz69xo5kfzve" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors hover:bg-brand-surfaceLight focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-goldBright" data-id="element-68" data-mp="mz6l8zxdbuy8">
              <span className="pr-8 text-sm font-semibold text-brand-purpleDark md:text-base" data-id="element-69" data-mp="2axqv7v2vcaxf">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" data-mp="38l989i3kbz78" />
            </button>
            <AnimatePresence initial={false} data-id="element-71" data-mp="33kbmkvjcgn0z">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} data-id="element-72" data-mp="2ym0i70btj4q5">
                  <p className="border-t border-brand-purple/15 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-73" data-mp="1j5rxb3662y25">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}